export default function DocumentIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        width={20}
        height={20}
        x={0}
        y={0}
        viewBox="0 0 60 60"
        className=""
      >
        <g>
          <path
            d="M50 60a4 4 0 0 0 4-4V16.242a4.024 4.024 0 0 0-1.172-2.828L40.586 1.172A4.024 4.024 0 0 0 37.758 0H10a4 4 0 0 0-4 4v52a4 4 0 0 0 4 4Zm.586-46H42a2 2 0 0 1-2-2V3.414ZM8 56V4a2 2 0 0 1 2-2h27.758a1.983 1.983 0 0 1 .242.024V12a4 4 0 0 0 4 4h9.976a1.983 1.983 0 0 1 .024.242V56a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2Z"
            fill="#000000"
            opacity={1}
            data-original="#000000"
          />
          <path
            d="M15 26h30a1 1 0 0 0 0-2H15a1 1 0 0 0 0 2ZM15 34h30a1 1 0 0 0 0-2H15a1 1 0 0 0 0 2ZM15 42h30a1 1 0 0 0 0-2H15a1 1 0 0 0 0 2ZM15 50h20a1 1 0 0 0 0-2H15a1 1 0 0 0 0 2Z"
            fill="#000000"
            opacity={1}
            data-original="#000000"
          />
        </g>
      </svg>
    </>
  );
}
